import React from 'react';
import * as Styles from './specification.styled';
import { IconBodyStyle, IconDoors, IconElectric, IconEngineSize, IconFuel, IconManualGearbox, IconRange, IconSeats, } from '@at/design-system-icons';
import { dataAttrTestId } from '@at/formatter-utils';
export var Specification = function (specification) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var isElectricFuelType = specification.fuelType === 'Electric';
    var specificationIcons = {
        seats: React.createElement(IconSeats, { title: "Number of seats", attributes: (_a = {}, _a[dataAttrTestId] = 'seats-icon', _a) }),
        doors: React.createElement(IconDoors, { title: "Number of doors", attributes: (_b = {}, _b[dataAttrTestId] = 'doors-icon', _b) }),
        bodyType: React.createElement(IconBodyStyle, { title: "Body type", attributes: (_c = {}, _c[dataAttrTestId] = 'body-type-icon', _c) }),
        fuelType: isElectricFuelType ? (React.createElement(IconElectric, { title: "Fuel type", attributes: (_d = {}, _d[dataAttrTestId] = 'fuel-type-electric-icon', _d) })) : (React.createElement(IconFuel, { title: "Fuel type", attributes: (_e = {}, _e[dataAttrTestId] = 'fuel-type-pump-icon', _e) })),
        transmission: (React.createElement(IconManualGearbox, { title: "Transmission type", attributes: (_f = {}, _f[dataAttrTestId] = 'transmission-icon', _f) })),
        engineSize: React.createElement(IconEngineSize, { title: "Engine size", attributes: (_g = {}, _g[dataAttrTestId] = 'engine-size-icon', _g) }),
        batteryRange: React.createElement(IconRange, { title: "Battery range", attributes: (_h = {}, _h[dataAttrTestId] = 'battery-range-icon', _h) }),
    };
    var specArray = Object.entries(specification);
    var filteredSpecArray = specArray.filter(function (_a) {
        var label = _a[1];
        return label;
    });
    return (React.createElement(React.Fragment, null, !!filteredSpecArray.length && (React.createElement(Styles.SpecificationList, { as: "ul" }, filteredSpecArray.map(function (_a) {
        var category = _a[0], label = _a[1];
        var CategoryIcon = specificationIcons[category];
        return (React.createElement(Styles.SpecificationItem, { as: "li", key: category },
            CategoryIcon,
            label));
    })))));
};
export default Specification;
